import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {User} from "../../../objects/user";
import {environment} from "../../../../environments/environment";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {FS3Notification} from "../../../objects/notification";
import {SharedDataService} from "../../../services/shared-data.service";
import {FormControl, FormGroup} from "@angular/forms";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

@Component({
  selector: 'app-profile-info-popup',
  templateUrl: './profile-info-popup.component.html',
  styleUrls: ['./profile-info-popup.component.css']
})
export class ProfileInfoPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() profile: User;
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  constructor(public dialog: MatDialog,
              public sharedDataService: SharedDataService) { }

  state = 'default';
  isOwner = false;
  isPrepaidBookings = false;
  forbidGuestBookings = true;
  discountExpired = false;
  discountExpireDate = new Date();
  isTrainer = false;
  isPublished = false;
  sortOrder = 0;
  profilePayloadParsed:object;
  ngOnInit(): void {
    this.isOwner = this.profile['native_group']['status'] == 'owner';
    this.isTrainer = this.profile['native_group']['status'] == 'trainer';
    this.profilePayloadParsed = JSON.parse(this.profile.payload);
    this.profilePayloadParsed = this.profilePayloadParsed ? this.profilePayloadParsed : {};
    this.isPrepaidBookings = !!this.profilePayloadParsed['new_booking_flow'];
    this.forbidGuestBookings = this.profilePayloadParsed['forbid_guest_booking'];
    if(this.profilePayloadParsed['discount_period_expiration']) {
      this.discountExpireDate.setTime(this.profilePayloadParsed['discount_period_expiration']*1000);
    }
    this.discountExpired = (new Date()).getTime() > this.discountExpireDate.getTime()
    this.isPublished = !this.profilePayloadParsed['skip_on_public_trainers_list'];
    this.sortOrder = this.profilePayloadParsed['trainer_sort_order'] ? this.profilePayloadParsed['trainer_sort_order'] : 100;
    const isPublishedControl = new FormControl(this.isPublished);
    this.componentForm.addControl('isPublishedControl', isPublishedControl);
    const sortOrderControl = new FormControl(this.sortOrder);
    this.componentForm.addControl('sortOrderControl', sortOrderControl);
    for (let i = 0; i < this.application.account.payload_parsed['trainers_types'].length; i++) {
      const trainer_type = this.application.account.payload_parsed['trainers_types'][i];
      const isChecked = this.profilePayloadParsed['trainer_type'] ? this.profilePayloadParsed['trainer_type'].includes(trainer_type) : false;
      const trainer_type_checkControl = new FormControl(isChecked);
      this.componentForm.addControl(trainer_type + '_checkControl', trainer_type_checkControl);
    }
    if(this.application.account.calendars) {
      this.application.account.calendars.map(calendarItem => {
        const isCalendarFilterChecked = this.profilePayloadParsed['calendars_filter'] ?
          this.profilePayloadParsed['calendars_filter'].find(cf => cf['id'] == calendarItem['ID']) : false;
        const calendar_filter_checkControl = new FormControl(isCalendarFilterChecked);
        this.componentForm.addControl('calendar_filter_checkControl_'+calendarItem['ID'], calendar_filter_checkControl);
        calendarItem['parsed_params']['columns'].map(calendarColumn => {
          const isCheckedColumn = (isCalendarFilterChecked && this.profilePayloadParsed['calendars_filter']) ?
            this.profilePayloadParsed['calendars_filter'].find(cf => {
              if(cf['id'] == calendarItem['ID']) {
                return cf['columns'].includes(calendarColumn['id'])
              }
              return false;
            }) : true;
          const calendar_column_checkControl = new FormControl(isCheckedColumn);
          if(!isCalendarFilterChecked) calendar_column_checkControl.disable()
          this.componentForm.addControl('calendar_column_checkControl_'+calendarItem['ID']+'_'+calendarColumn['id'], calendar_column_checkControl);
        });
      });
    }
  }

  public trainerToggle(event: MatSlideToggleChange): void {
    this.isTrainer = event.checked;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.profile['id'];
    params['status_change'] = this.isTrainer ? 'trainer' : 'member';
    this.profileUpdateInternal(params);
  }

  public changeTrainerDescription(): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'message-popup',
        payload: {old_message: this.profilePayloadParsed['trainer_description'], 'popup_state': 'description'},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          let params = new Object();
          params['gid'] = environment['gid'];
          params['g_hash'] = environment['g_hash'];
          params['target_profile_id'] = this.profile['id'];
          params['payload'] = {};
          params['payload']['trainer_description'] = dialogPayload['message'];
          this.updateProfilePayload(params);
        }
      })
  }

  public openProfileEditPopup(): void {
    //todo
  }

  public rotateImage(degrees): void {
    if(this.state == 'loading') return;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['url'] = this.profile.picture_src_preview;
    params['degrees'] = degrees;
    this.state = 'loading';
    this.application.apiService.rotateImage(params).subscribe(
      res => {
        this.state = 'default';
        if(res['url']) {
          let params = new Object();
          params['gid'] = environment['gid'];
          params['g_hash'] = environment['g_hash'];
          params['target_profile_id'] = this.profile['id'];
          params['picture_src_preview'] = res['url'];
          params['picture_src_ava'] = res['url'];
          params['picture_src_icon'] = res['url'];
          this.profileUpdateInternal(params);
        }
      },
      error => {
        this.state = 'error';
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
      }
    );
  }

  public profileUpdateInternal(params) {
    this.state = 'loading';
    this.application.apiService.updateProfileInternal(params).subscribe(
      res => {
        this.state = 'default';
        //this.application.getCurrentUser();
        if(params['status_change']) {
          this.profile['native_group']['status'] = params['status_change'];
        }
        if(params['picture_src_preview']) {
          this.profile.picture_src_preview = params['picture_src_preview'];
          this.profile.picture_src_ava = params['picture_src_ava']
          this.profile.picture_src_icon = params['picture_src_icon']
        }
        let notification = new FS3Notification();
        notification.type = 'success';
        notification.text = AppComponent.getLabel('updated');
        this.sharedDataService.pushNotification(notification);
      },
      error => {
        this.state = 'error';
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
      }
    );
  }

  public prepaidToggle(event: MatSlideToggleChange): void {
    this.isPrepaidBookings = event.checked;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.profile['id'];
    params['payload'] = {};
    params['payload']['new_booking_flow'] = this.isPrepaidBookings; //paid bookings (vip booking otherwise)
    this.updateProfilePayload(params);
  }

  public guestBookingToggle(event: MatSlideToggleChange): void {
    this.forbidGuestBookings = event.checked;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.profile['id'];
    params['payload'] = {};
    params['payload']['forbid_guest_booking'] = this.forbidGuestBookings;
    this.updateProfilePayload(params);
  }

  public discountExpireChange(event: MatDatepickerInputEvent<Date>): void {
    if(this.state == 'loading') return;
    this.discountExpireDate = event.value;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.profile['id'];
    params['payload'] = {};
    params['payload']['discount_period_expiration'] = this.discountExpireDate.getTime()/1000;
    this.updateProfilePayload(params);
  }

  public calendarFilterToggle(event: MatSlideToggleChange,calendarID): void {
    const calendarToggled = event.checked;
    this.application.account.calendars.map(calendarItem => {
      if(calendarItem['ID'] != calendarID) return;
      calendarItem['parsed_params']['columns'].map(calendarColumn => {
        const calendar_column_checkControl = this.componentForm.get('calendar_column_checkControl_'+calendarItem['ID']+'_'+calendarColumn['id']);
        calendarToggled ? calendar_column_checkControl.enable() : calendar_column_checkControl.disable();
      });
    });
  }

  public handleSubmit(): void {
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.profile['id'];
    params['payload'] = {};
    params['payload']['skip_on_public_trainers_list'] = !this.componentForm.get('isPublishedControl').value;
    params['payload']['trainer_sort_order'] = this.componentForm.get('sortOrderControl').value;
    params['payload']['trainer_type'] = [];
    this.application.account.payload_parsed['trainers_types'].map(trainer_type => {
      if(this.componentForm.get(trainer_type + '_checkControl').value) {
        params['payload']['trainer_type'].push(trainer_type);
      }
    });

    if(this.application.account.calendars) {
      params['payload']['calendars_filter'] = [];
      this.application.account.calendars.map(calendarItem => {
        const isCalendarFilterChecked = this.componentForm.get('calendar_filter_checkControl_'+calendarItem['ID']).value;
        if(isCalendarFilterChecked) {
          const saveCalendarFilter = {};
          params['payload']['calendars_filter'].push(saveCalendarFilter);
          saveCalendarFilter['id'] = calendarItem['ID'];
          saveCalendarFilter['columns'] = [];
          calendarItem['parsed_params']['columns'].map(calendarColumn => {
            const isCalendarFilterChecked = this.componentForm.get('calendar_column_checkControl_'+calendarItem['ID']+'_'+calendarColumn['id']).value;
            if(isCalendarFilterChecked) {
              saveCalendarFilter['columns'].push(calendarColumn['id']);
            }
          });
        }
      });
    }
    this.updateProfilePayload(params);
  }

  protected updateProfilePayload(params) {
    this.state = 'loading';
    this.application.apiService.updateProfilePayload(params).subscribe(
      res => {
        this.state = 'default';
        let payload = params['payload'];
        if(payload['trainer_description'] != null) this.profilePayloadParsed['trainer_description'] = payload['trainer_description'];
        if(payload['new_booking_flow'] != null) this.profilePayloadParsed['new_booking_flow'] = payload['new_booking_flow'];
        if(payload['forbid_guest_booking'] != null) this.profilePayloadParsed['forbid_guest_booking'] = payload['forbid_guest_booking'];
        if(payload['skip_on_public_trainers_list'] != null) this.profilePayloadParsed['skip_on_public_trainers_list'] = payload['skip_on_public_trainers_list'];
        if(payload['trainer_sort_order'] != null) this.profilePayloadParsed['trainer_sort_order'] = payload['trainer_sort_order'];
        if(payload['trainer_type'] != null) this.profilePayloadParsed['trainer_type'] = payload['trainer_type'];
        if(payload['calendars_filter'] != null) this.profilePayloadParsed['calendars_filter'] = payload['calendars_filter'];
        if(payload['discount_period_expiration'] != null) {
          this.profilePayloadParsed['discount_period_expiration'] = payload['discount_period_expiration'];
          this.discountExpired = (new Date()).getTime() > this.discountExpireDate.getTime()
        }
        this.profile.payload = JSON.stringify(this.profilePayloadParsed);
        let notification = new FS3Notification();
        notification.type = 'success';
        notification.text = AppComponent.getLabel('updated');
        this.sharedDataService.pushNotification(notification);
      },
      error => {
        this.state = 'error';
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
        let notification = new FS3Notification();
        notification.type = 'error';
        notification.text = AppComponent.getLabel(errMsg);
        this.sharedDataService.pushNotification(notification);
      }
    );
  }

  public showUser(): void {
    window.open('/'+this.application.appLang+'/squash/userview/'+this.profile.id, "_blank");
  }
  messageUser(): void {
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }

    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '__start_private_chat_with_user_'+this.profile.id+'_'+this.profile.sig;
      window.open(environment['viber_url']+exit_context)
    }
  }

  public onNoClick(): void {
    //this.dialogRef.close();
    this.close.emit()
  }

}
